export function getParentElement(
    element: HTMLElement | null,
    tagName: string | string[],
    maxDepth: number = 10,
    ignoreClass: string | null = null,
    depth: number = 1,
): HTMLElement | null {
    if (element === null) {
        return null;
    }
    const elementTagName = (element.tagName || '').toLowerCase();
    const tagNames = (Array.isArray(tagName) ? tagName : [tagName]).map((name) =>
        name.toLowerCase(),
    );
    if (
        tagNames.indexOf(elementTagName) !== -1 &&
        (ignoreClass === null || !element.classList.contains(ignoreClass))
    ) {
        return element;
    }
    const parent = (element.parentNode as HTMLElement) || null;
    return parent !== null && parent.tagName !== 'BODY' && depth < maxDepth
        ? getParentElement(parent, tagName, maxDepth, ignoreClass, depth + 1)
        : null;
}

export function isInElement(
    element: HTMLElement | null,
    tagName: string | string[],
    maxDepth: number = 10,
    ignoreClass: string | null = null,
    depth: number = 1,
): boolean {
    return getParentElement(element, tagName, maxDepth, ignoreClass, depth) !== null;
}

export function isInInteractiveElement(
    element: HTMLElement | null,
    maxDepth: number = 10,
    ignoreClass: string | null = null,
    depth: number = 1,
): boolean {
    return isInElement(
        element,
        ['canvas', 'a', 'button', 'input', 'textarea', 'select', 'form'],
        maxDepth,
        ignoreClass,
        depth,
    );
}

export function isInInputElement(
    element: HTMLElement | null,
    maxDepth: number = 10,
    ignoreClass: string | null = null,
    depth: number = 1,
): boolean {
    return isInElement(element, ['input', 'textarea', 'select'], maxDepth, ignoreClass, depth);
}

export default isInElement;
